// extracted by mini-css-extract-plugin
export default {"addLineItem":"WorkLogAdditionalDetails_addLineItem__bEE3i"};